import { Visibility, VisibilityOff } from '@mui/icons-material';
import {
  FilledTextFieldProps,
  IconButton,
  InputAdornment,
} from '@mui/material';
import { ChangeEventHandler, ForwardedRef, forwardRef, useState } from 'react';
import { InputField } from '../input-field';

interface Props extends Omit<FilledTextFieldProps, 'variant'> {
  label: string;
  value: string;
  onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  onBlur: () => void;
  error: boolean;
  helperText?: string;
  disabled?: boolean;
  name?: string;
  required?: boolean;
}

const PasswordInput = forwardRef(
  (
    {
      value,
      label,
      error,
      helperText,
      onBlur,
      onChange,
      disabled,
      name,
      required,
      inputProps,
      ...other
    }: Props,
    ref: ForwardedRef<HTMLInputElement>,
  ) => {
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    return (
      <InputField
        {...other}
        label={label}
        name={name}
        ref={ref}
        required={required}
        disabled={disabled}
        onBlur={onBlur}
        onChange={onChange}
        value={value}
        autoComplete="password"
        error={error}
        helperText={helperText}
        type={isPasswordVisible ? 'text' : 'password'}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end" sx={{ mr: 2 }}>
              <IconButton
                aria-label="toggle password visibility"
                onClick={() =>
                  setIsPasswordVisible(
                    prevIsPasswordVisible => !prevIsPasswordVisible,
                  )
                }
                data-testid="password-visibility"
                edge="end">
                {isPasswordVisible ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
        inputProps={inputProps}
      />
    );
  },
);

export default PasswordInput;
